const TRANSLATE = {
  title: 'Public Tokens',
  newPublicToken: 'New public token',
  editPublicToken: 'Edit public token',
  name: 'Name',
  availableUses: 'Available uses',
  validUntil: 'Valid until',
  enabled: 'Enabled',
  action: 'Action',
  maxExecution: 'Max execution',
  expiresAt: 'Expires at',
  usageType: 'Usage type',
  conditions: 'Conditions',
  payload: 'Payload',
  remainingUses: 'Remaining uses',
  expireDate: 'Expire date',
  publicUrl: 'Public URL',
  calls: '{{count}} call',
  calls_plural: '{{count}} calls',
  noLimit: 'No limit',
  noExpireDate: 'No expire date',
  createdAt: 'Created at',
  moreDetails: 'More details',
  lessDetails: 'Less details',
  called: 'Called',
  error: 'Error',
  success: 'Success',
  confirmRemove: 'Are you sure you want to remove?'
}

export default TRANSLATE
